import React, { useState } from "react";
import clienteAxios from "../../axios"; // Asegúrate de que esta sea la ruta correcta

const ModalAgregarPedido = ({ show, onClose, restauranteId, onPedidoAgregado }) => {
    const [nuevoPedido, setNuevoPedido] = useState({
        monto_total: ""
    });

    const handleAgregarPedido = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "pedidos",
                restaurante_id: restauranteId,  // Relacionamos el nuevo pedido con el restaurante
                monto_total: nuevoPedido.monto_total  // Monto total del pedido
            });
            setNuevoPedido({ monto_total: 0 });
            onPedidoAgregado();  // Actualizamos la lista después de agregar
            onClose();  // Cerramos el modal
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) {
        return null;  // No renderizamos el modal si show es false
    }

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg">
                <h2 className="text-lg font-semibold mb-4">Agregar Nuevo Pedido</h2>
                <form onSubmit={handleAgregarPedido}>
                    <input
                        type="number"
                        placeholder="Monto Total"
                        value={nuevoPedido.monto_total}
                        onChange={(e) => setNuevoPedido({ ...nuevoPedido, monto_total: e.target.value })}
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded mr-2">
                        Agregar Pedido
                    </button>
                    <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded">
                        Cancelar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarPedido;
